import type { DropdownFilterOption } from "../types";

export const DROPDOWN_FILTER_OPTIONS: DropdownFilterOption[] = [
  { id: "open", label: "Open requests" },
  { id: "active", label: "Active requests" },
  { id: "queued", label: "Queued requests" },
  { id: "completed", label: "Completed requests" },
  { id: "overdue", label: "Overdue requests" },
  { id: "due-today", label: "Due today" },
  { id: "all", label: "All requests" },
  { id: "drafts", label: "Drafts" },
];
